import { BrowserDynamicTestingModule } from "@angular/platform-browser-dynamic/testing";

export class AdvancedShippingNotice {
    constructor() {
        this.OnlineShippingNoticeDocuments = [];
        this.OnlineShippingNoticeServices = [];
        this.OnlineShippingNoticeLines = [];
    }

    WhsCode:string;
    OwnerCode:string;
    OopAsnNo:string;
    PoNo:string;
    TransCode:string;
    Email:string;
    Supplier:string;
    SupplierName:string;
    EtaDate:string;
    EtaDateString:string;
    Remarks1:string;
    StatusCode:string;
    CreatedBy:string;
    CreatedDate:string;
    UpdatedBy:string;
    UpdatedDate:string;
    DateFormat:string;
    OnlineShippingNoticeDocuments:any[];
    OnlineShippingNoticeServices:any[];
    OnlineShippingNoticeLines:any[];
}


// WEBPACK FOOTER //
// ./src/app/data/models/transaction/op/inbound/asn.ts